export const environment = {
  projectId: "blazebite-dev",
  appId: "1:1058704097780:web:e10ead8a5cdc1e060139a1",
  databaseURL: "https://blazebite-dev.firebaseio.com",
  storageBucket: "blazebite-dev.appspot.com",
  apiKey: "AIzaSyAX9dHElK0atRGY4ImVEoVcVYD6WFIPHvI",
  authDomain: "blazebite-dev.firebaseapp.com",
  messagingSenderId: "1058704097780",
  measurementId: "G-XVPGR85L1T",
  name: 'development',
  version: '1.0.0',
  portalBaseUrl: 'https://qa-portal.blazebite.com',
  adminBaseUrl: 'https://dev-admin.blazebite.com',
  ordersBaseUrl: 'https://dev-orders.blazebite.com',
  mapboxAccessToken: 'pk.eyJ1IjoiYmxhemViaXRlYWRtaW4iLCJhIjoiY21pcTZzZ2lpMGVrMTNlcG9yYTVoc2x0cSJ9.Xt0JreNAiaTognotlDRH3A'
};